'use client';
import { ComponentType } from 'react';
import { Props as DeliveryReturnComponentProps } from './delivery-return.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicDeliveryReturnComponent: ComponentType<DeliveryReturnComponentProps> = dynamic(
  () => import('./delivery-return.component')
);

export default DynamicDeliveryReturnComponent;

export function calculateDeliveryReturnPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 750 },
    { sinceWidth: 768, height: 750 },
    { sinceWidth: 1024, height: 800 }
  ];

  return {
    heightSinceWidth
  };
}
